import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { classificationList, classificationStatus, isEditClassification, delClassification } from './request';
import categoryModel from './categoryModel.vue';
let expandedRowKeys = [];
const rowSelection = {
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
    expandedRowKeys = selectedRows;
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    expandedRowKeys = selectedRows;
  },
  getCheckboxProps: record => ({
    props: {
      disabled: record.isEdit == 0,
      // Column configuration not to be checked
      name: record.name
    }
  })
};
export default {
  components: {
    categoryModel
  },
  data() {
    return {
      categoryShow: false,
      form: {
        name: ''
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns: [
        // {title: '分类名称',  dataIndex: 'name', key: '1',align: 'center'},
        // {title: '排序',  dataIndex: 'sort', key: '2',align: 'center'},
        // {title: '状态',  dataIndex: 'status', key: '3',align: 'center',scopedSlots: {customRender: 'status'}},
        // {title: '更新时间',  dataIndex: 'updateAt', key: '5',align: 'center',width: 200},
        // {title: '操作', width: 250, key: '6',align: 'center' ,scopedSlots: {customRender: 'action'}}
      ],
      expandedRowKeys,
      rowSelection
    };
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    }
  },
  created() {
    this.getTableFun();
  },
  methods: {
    getTableFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      classificationList(obj).then(res => {
        if (res.fieldConfig) {
          this.columns = res.fieldConfig.map(item => {
            item.slots = {
              title: item.title
            };
            delete item.title;
            return item;
          });
          this.columns.push({
            slots: {
              title: this.$t('操作')
            },
            width: 250,
            key: '6',
            align: 'center',
            scopedSlots: {
              customRender: 'action'
            }
          });
        }
        this.data = res.itemsRender || res.items || [];
        // console.log(res,6966);
        // this.data=res.items;
        this.pagination.total = res.totalNum;
      });
    },
    getClassificationTable() {
      this.pagination.current = 1;
      this.getTableFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getTableFun();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleAdd() {
      this.categoryShow = true;
      this.$nextTick(() => {
        this.$refs.categoryForm.init({});
      });
    },
    handleEdit(val) {
      this.categoryShow = true;
      this.$nextTick(() => {
        this.$refs.categoryForm.init(val);
      });
    },
    handleDelete(val) {
      delClassification({
        classificationIds: val.classificationId
      }).then(res => {
        this.$message.success(this.$t('删除成功'));
        this.getTableFun();
      });
    },
    checkedFun(val) {
      console.log(val);
      if (!this.isAuth('customer.insuranceClassificationStatus')) {
        return false;
      }
      classificationStatus({
        classificationId: val.classificationId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功'));
        val.status = val.status == 1 ? 0 : 1;
      });
    },
    //没有用到
    checkedFun2(val) {
      console.log(val);
      // if(!this.isAuth('home.customerUserStatus')){
      //     return false
      // }
      isEditClassification({
        classificationId: val.classificationId,
        isEdit: val.isEdit == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功'));
        val.isEdit = val.isEdit == 1 ? 0 : 1;
      });
    },
    handleDel() {
      if (expandedRowKeys.length == 0) {
        this.$message.error(this.$t('请选择') + this.$t('要删除的数据'));
        return false;
      }
      let arr = [];
      expandedRowKeys.map(item => {
        arr.push(item.classificationId);
      });
      delClassification({
        classificationIds: arr.join(',')
      }).then(res => {
        expandedRowKeys = [];
        this.$message.success(this.$t('删除成功'));
        this.getTableFun();
      });
    }
  }
};